import { Box } from "@mui/material";
import React from "react";
import { TravelAssistanceStyles } from "../Styles";

import { GadgetsProtectionStyles } from "../Styles";
import blogBackground from "../../assets/images/Home/Blog.png";
import HeroSection from "../../components/TravelComponents/HeroSections";
import QuickLinksSection from "../../components/TravelComponents/QuickLinksSection";
import TravelReasonCard from "../../components/TravelComponents/TravelReasonCard";

import BGCIMGONE from "../../assets/Banner/TravelBanner/TravelBannerOne.png";
import BGCIMGTWO from "../../assets/Banner/TravelBanner/TravelBannerTwo.png";
import BGCIMGTHR from "../../assets/Banner/TravelBanner/TravelBannerThree.png";
import BGCIMGFOR from "../../assets/Banner/TravelBanner/TravelBannerFour.png";

const TravelAssistance = () => {
  const MPBannerImages = [BGCIMGONE, BGCIMGTWO, BGCIMGTHR, BGCIMGFOR];

  return (
    <Box sx={GadgetsProtectionStyles.BackgroundBox(blogBackground)}>
      <Box mt={10} sx={[TravelAssistanceStyles.MainBannerBox]}>
        <Box sx={{ padding: "20px 0px" }}>
          <HeroSection bannerList={MPBannerImages} />

          <QuickLinksSection />

          <TravelReasonCard />

          {/* ****** Banner Container *******/}
          {/* <Box sx={{ mt: { xs: 3, sm: 3, md: 6, lg: 6 } }}>
            <BannerCarousel images={MPBannerImages} />
          </Box> */}

          {/* ****** Plan Heading Container *******/}
          {/* <Box textAlign="center" mb={6}>
            <Typography
              variant="h4"
              fontWeight="600"
              mt={5}
              mb={1}
              sx={GadgetsProtectionStyles.PlanHeading}
            >
              Let's find you the best plan
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={GadgetsProtectionStyles.SubHeading}
            >
              Quick. Convenient. Best value-for-money protection plan.
            </Typography>
          </Box> */}

          {/* ****** Plan Card Container *******/}
          {/* <Box sx={GadgetsProtectionStyles.CenteredBox}>
            <Grid
              container
              spacing={2}
              mb={5}
              sx={GadgetsProtectionStyles.GridCentered}
            >
              {MOBILEPLANS.map((plan, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <PlanCard {...plan} />
                </Grid>
              ))}
            </Grid>
          </Box> */}

          {/* ****** Claim Container *******/}
          {/* <SectionHeading title="Hassle-free and convenient claim process" />
          <Grid container spacing={4} sx={GadgetsProtectionStyles.GridCentered}>
            <Grid item xs={12} sm={6} md={3}>
              <StepCard
                step={1}
                title="Claim in Minutes"
                description="Call or email us — we’ll handle the rest."
                icon={
                  <img
                    src={Claims}
                    alt="Step Icon"
                    style={{ width: 100, height: 100 }}
                  />
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <StepCard
                step={2}
                title="Doorstep Pickup"
                description="We’ll collect your device. No stress, no hassle."
                icon={
                  <img
                    src={PickUp}
                    alt="Step Icon"
                    style={{ width: 100, height: 100 }}
                  />
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <StepCard
                step={3}
                title="Pro Repair"
                description="Certified experts restore your device to perfection.."
                icon={
                  <img
                    src={PhoneRepair}
                    alt="Step Icon"
                    style={{ width: 100, height: 100 }}
                  />
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <StepCard
                step={4}
                title="Swift Return"
                description="Your device, as good as new, delivered to you."
                icon={
                  <img
                    src={Delivery}
                    alt="Step Icon"
                    style={{ width: 100, height: 100 }}
                  />
                }
              />
            </Grid>
          </Grid> */}

          {/* ****** Rating Section ****** */}
          {/* <Box mt={7}>
            <SectionHeading title="Everything that we do is designed around you" />
          </Box>
          <RatingCard /> */}

          {/* ****** Video Testimonial Container ****** */}
          {/* <Grid container spacing={4} mt={4}>
            <Grid
              item
              xs={12}
              md={12}
              sx={GadgetsProtectionStyles.GridCentered}
            >
              <VideoTestimonial />
            </Grid>
          </Grid> */}

          {/* ****** Testimonial Cards Container ****** */}
          {/* <Grid mt={3} item xs={12} sm={6} md={4}>
            <Grid
              container
              spacing={2}
              sx={GadgetsProtectionStyles.GridCentered}
            >
              <Grid item xs={12} sm={6} md={3}>
                <TestimonialCard
                  isImg={true}
                  initials={require("../../assets/images/Manya.png")}
                  name="Manya"
                  rating={5}
                  review="Quick claim, impressive service. Grateful for prompt support!"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TestimonialCard
                  isImg={true}
                  initials={require("../../assets/images/")}
                  name="Shivani"
                  rating={5}
                  review="Swift claim, excellent service, highly recommended!"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TestimonialCard
                  isImg={true}
                  initials={require("../../assets/images/Ankur.jpeg")}
                  name="Ankur"
                  rating={5}
                  review="Hassle-free insurance process, professional handling!"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TestimonialCard
                  initials="AK"
                  name="Akash"
                  rating={5}
                  review="Phone restored, very satisfied, highly recommended!"
                />
              </Grid>
            </Grid>
          </Grid> */}
        </Box>
      </Box>
    </Box>
  );
};

export default TravelAssistance;
// 858 Lines
